<template>
  <div class="index-wrap" @click="outerClick" >

    <VideoSwiper :company_video="company_video"></VideoSwiper>

    <section class="search">
      <div class="search__wrap-ttl-bubble">
        <h1 class="ttl-bubble is-top">気になる企業の<strong class="ttl__span">初任給</strong>を比較しよう</h1>
      </div>
      <div class="search__wrap">
        <form action="" class="form" @submit="search">
          <div class="form__wrap is-search-text">
            <input
                v-model="searchStore.search_text"
                class="form__input"
                type="text"
                name="search_text"
                placeholder=""
            >
            <button
                @click="search"
                type="button" class="form__btn01"
            ></button>
            <p class="form-info">複数社名で検索 A社 B社 C社</p>
          </div>
          <div class="form__wrap is-link">
            <div class="form__wrap-link">
              <span
                  @click="toggleSelector"
                  data-pick-type="industry"
                  class="form__link is-industry">業種</span>
            </div>
            <div class="form__wrap-link">
              <span
                  @click="toggleSelector"
                  data-pick-type="area"
                  class="form__link is-area">エリア<span class="form__link-s">（本社所在地）</span></span>

            </div>
          </div>
          
          <SearchPick :pageData="pageData"></SearchPick>
          
          <div class="form__wrap is-checkbox">
            <div v-for="listing in search_options.listings" class="form__listing">
              <input
                  :id="'listing'+listing.id"
                  type="checkbox"
                  name="listings"
                  :value="listing.id"
                  v-model="searchStore.listings"
                  class="form__checkbox"
              >
              <label
                  :for="'listing'+listing.id"
                  class="form__label"
              >{{ listing.name }}</label>
            </div>
          </div>
          <div class="form__wrap is-no-border is-salary">
            <div class="form__salary">
              <p class="form__ttl">初任給額</p>
            </div>
            <div
                v-for="starting_salary in search_options.starting_salary" class="form__salary"
            >
              <input
                  @click="clickStartingSalary"
                  class="form__radio"
                  :id="'starting_salary'+starting_salary.id"
                  type="radio"
                  name="starting_salary"
                  :value="starting_salary.id"
                  v-model="searchStore.starting_salary"
              >
              <label
                  class="form__label-s"
                  :for="'starting_salary'+starting_salary.id"
              >{{ starting_salary.name }}</label>
            </div>
          </div>
          <div class="form__wrap is-no-border">
            <button
                @click="search"
                type="button"
                class="form__btn02"
            >検索
            </button>
          </div>
        </form>
      </div>
    </section>

    <section class="rank">
      <h2 class="rank__ttl">注目の業種別ランキング</h2>
      <div class="rank__wrap">
        <div
            v-for="hot_industry in search_options.hot_industries"
            :data-id="hot_industry.industry_id"
            @click="selectHotIndustry"
            :class="(searchStore.hot_industry_id == hot_industry.industry_id)?'rank__wrap-s is-active':'rank__wrap-s'">
          <span class="rank__link">{{ hot_industry.industry_name }}</span>
        </div>
      </div>
    </section>

    <section class="rank-result">
      <h2 class="rank-result__ttl">検索結果<strong>{{ search_result_cnt }}</strong>件</h2>
      <div class="rank-result__wrap">
        <span
            v-for="target in search_options.target"
            :data-key="target.key"
            @click="sort"
            :class="(searchStore.target==target.key)?'rank-result__link is-active':'rank-result__link'"
        >{{ target.label }}</span>
      </div>
    </section>

    <section class="chart is-search">
      <div v-if="!hasSearchParam" class="chart__wrap is-contract is-top">
        <CompanyList
            :company_info="contract_company"
            :options="companyListOptionsContract"
        ></CompanyList>
      </div>
      <div class="chart__wrap">
        <CompanyList
            :company_info="company_info"
            :options="companyListOptions"
        ></CompanyList>
      </div>
      <div
          v-if="has_more_pages"
          class="chart-btn">
        <span
            @click="more"
            class="btn-bd"
        >さらに見る</span>
      </div>
      
      <div v-if="hasSearchParam" class="chart__wrap is-contract is-bottom">
        <CompanyList
            :company_info="contract_company"
            :options="companyListOptionsContract"
        ></CompanyList>
      </div>
      
    </section>


  </div>
</template>
<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useSearchStore} from "../../stores/search";
import {usePageStore} from "../../stores/page";
import {NaviClient} from "../../api/NaviClient"
import CompanyList from "../parts/CompanyList.vue"
import {NaviRequest} from "../../api/NaviRequest";
import VideoSwiper from "../parts/VideoSwiper.vue";
import SearchPick from "../parts/SearchPick.vue";

//初期データを取得設定
const pageDataStore = usePageStore();
const pageData = pageDataStore.pageData;
const search_options = pageData.search_options;
const company_info = ref(pageData.company_info);
const contract_company = ref(pageData.contract_company);
const has_more_pages = ref(pageData.has_more_pages);
const search_result_cnt = ref(pageData.search_result_cnt);
const companyListOptions = {like: true, share: true, search: true};
const companyListOptionsContract = {like: true, share: true, search: false};
let company_video = pageData.company_video;
let hasSearchParam = ref(false);

//検索条件を初期化
const searchStore = useSearchStore();
searchStore.init(pageData.search_condition);

onMounted(() => {
  document.querySelectorAll(`[data-role="area"]`).forEach((area: HTMLInputElement | any) => {
    const index = area.dataset.index;
    const checkPrefectures = document.querySelectorAll(`[data-role="prefecture"][data-index="${index}"]:checked`);
    if (checkPrefectures.length) {
      area.checked = true;
    }
  });
})




//業種/エリア外をクリックで閉じる
const outerClick = (e) => {
  const picker = e.target.closest('.picker');
  if (picker != null) return;
  const wrap = e.target.closest('.form__wrap-link');
  if (wrap != null) return;
  closePicker();
}

//業種/エリア表示
const toggleSelector = (e) => {
  const type = e.currentTarget.dataset.pickType;
  const picker:any = document.querySelector('.picker');
  if(type == picker.dataset.pickType){ //現在開いていたら閉じる
    picker.dataset.pickType = '';
  }else{
    picker.dataset.pickType = type;
  }
}
const closePicker = () => {
  const picker:any = document.querySelector('.picker');
  picker.dataset.pickType = '';
}


//ラジオボタンをチェックボックス風に解除できるようにする
const clickStartingSalary = (e) => {
  let input = e.currentTarget
      .closest('.form__salary')
      .querySelector('input');
  let val = parseInt(input.value);
  if (val == searchStore.starting_salary) {
    input.checked = false;
    searchStore.starting_salary = null;
    e.preventDefault;
    e.stopPropagation();
  }
};

const selectHotIndustry = (e) => {
  e.preventDefault();
  searchStore.reset();
  searchStore.hot_industry_id = e.target.dataset.id;
  searchStore.target = NaviRequest.TARGET_SALARY;
  searchStore.page = 1;
  _search();
};

//並び替え押下時
const sort = (e) => {
  searchStore.target = e.target.dataset.key;
  searchStore.page = 1;
  _search();
};

//もっと見るボタン押下時
const more = () => {
  searchStore.restoreCache(); //もっと見る場合は前回の検索条件を復元して次のページを取得する
  searchStore.page++;
  _search();
};

//検索ボタン押下時
const search = (e) => {
  e.preventDefault();
  searchStore.hot_industry_id = '';
  searchStore.page = 1;
  _search();
};

//実際の検索処理
const _search = () => {

  hasSearchParam.value = searchStore.hasSearchParam();
  
  NaviClient.search(searchStore.params).then((json: any) => {
    search_result_cnt.value = json.search_result_cnt;
    has_more_pages.value = json.has_more_pages;
    //1ページ目の場合は上書き、2ページ目以降は追加
    if (json.page == 1) {
      company_info.value = json.company_info;
      contract_company.value = json.contract_company;
    } else {
      for (let i = 0; i < json.company_info.length; i++) {
        company_info.value.push(json.company_info[i]);
      }
    }

    //検索結果をキャッシュする(検索条件をいじった後にもっと見るを押したときに前回の検索条件を復元するため)
    searchStore.cache();
  }).catch((error) => {
    console.log(error)
  });
}
</script>